import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Catalogs|Achievement|List|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialAchievements,
	portal: 'SP',
};
const columnDescriptionStart = 'Column heading for: ';

type LocNameStart = 'SPAchievementsCatalog';
export type SPAchievementsCatalogLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelFilterByType`
	| `${LocNameStart}LabelFilterByGroup`
	| `${LocNameStart}LabelGroup`
	| `${LocNameStart}LabelId`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelStartDate`
	| `${LocNameStart}LabelEndDate`;

export const spAchievementsCatalogLocs: LocDefs<SPAchievementsCatalogLocNames> = {
	SPAchievementsCatalogTitlePage: {
		defaultValue: 'Achievement Catalog',
		description: 'Page title.',
		displayPath: `${pathStart}Achievement Catalog`,
		displayType: 'Title',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.Title.PageTitle',
		...sharedProperties,
	},
	SPAchievementsCatalogLabelType: {
		defaultValue: 'Type',
		description: `${columnDescriptionStart}Type`,
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.ColumnHeading.Type',
		...sharedProperties,
	},
	SPAchievementsCatalogLabelFilterByType: {
		defaultValue: 'Filter by Type',
		description: 'Label for the filter dropdown: Filter by Type.',
		displayPath: `${pathStart}Filter by Type`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.FieldLabel.FilterByType',
		...sharedProperties,
	},
	SPAchievementsCatalogLabelFilterByGroup: {
		defaultValue: 'Filter by Group',
		description: 'Label for the filter dropdown: Filter by Group.',
		displayPath: `${pathStart}Filter by Group`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.FieldLabel.FilterByGroup',
		...sharedProperties,
	},
	SPAchievementsCatalogLabelGroup: {
		defaultValue: 'Group',
		description: `${columnDescriptionStart}Group`,
		displayPath: `${pathStart}Group`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.ColumnHeading.Group',
		...sharedProperties,
	},
	SPAchievementsCatalogLabelId: {
		defaultValue: 'ID',
		description: `${columnDescriptionStart}ID`,
		displayPath: `${pathStart}ID`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.ColumnHeading.Id',
		...sharedProperties,
	},
	SPAchievementsCatalogLabelName: {
		defaultValue: 'Name',
		description: `${columnDescriptionStart}Name`,
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.ColumnHeading.Name',
		...sharedProperties,
	},
	SPAchievementsCatalogLabelStartDate: {
		defaultValue: 'Start Date',
		description: `${columnDescriptionStart}Start Date`,
		displayPath: `${pathStart}Start Date`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.ColumnHeading.StartDate',
		...sharedProperties,
	},
	SPAchievementsCatalogLabelEndDate: {
		defaultValue: 'End Date',
		description: `${columnDescriptionStart}End Date`,
		displayPath: `${pathStart}End Date`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Catalogs.Achievements.ColumnHeading.EndDate',
		...sharedProperties,
	},
};

export type SPAchievementsCatalogLocType = LocMap<SPAchievementsCatalogLocNames>;
